// Import controller
import deleteMediaCTRL from 'controllers/mediaCenter/deleteMedia'

// Actions
export const START_DELETE_MEDIA = 'START_DELETE_MEDIA'
export const SUCCESS_DELETE_MEDIA = 'SUCCESS_DELETE_MEDIA'
export const FAILED_DELETE_MEDIA = 'FAILED_DELETE_MEDIA'

// Action Creator
export function deleteMedia(index, schoolId, prefix, callback){
  return function(dispatch) {

    dispatch({
      type: START_DELETE_MEDIA,
      payload: {deleting: true, index}
    })

    deleteMediaCTRL(schoolId, prefix)
    .then((result) => {
      dispatch({
        type: SUCCESS_DELETE_MEDIA,
        payload: {...result, deleting: false}
      })

      if(typeof(callback) == 'function'){
        callback()
      }
      
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_DELETE_MEDIA,
        payload: err
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/MediaCenter/redux/actions/deleteMedia.js